/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { FC } from 'react';
import styles from './tool-button-wrapper.module.css';

interface ToolButtonWrapperProps {
  onClick?: (arg: any) => any;
  className?: string;
}
export const ToolButtonWrapper: FC<ToolButtonWrapperProps> = ({
  children,
  onClick,
  className = '',
}) => {
  return (
    <div className={`${styles.wrapper} ${className}`} onClick={onClick}>
      {children}
    </div>
  );
};
